/**
 * DataAPIでテンプレートを再構築します。
 *
 * @param {Object} options - 設定オブジェクト
 * @param {Number} options.siteId - サイトID
 * @param {Number} options.templateId - テンプレートID
 * @param {Number} options.templateName - テンプレート名
 * @param {Boolean} [options.noConfirm=false] - trueを設定すると確認画面を表示しない
 */
import { msg } from './msg.js';
import { modalConfirm } from './modalConfirm.js';

export function rebuildTemplate(options) {
    const op = {
        siteId: 0,
        templateId: 0,
        templateName: '',
        noConfirm: false,
        ...options
    };

    if (!op.siteId) {
        return alert('The siteId option is required.');
    }
    if (!op.templateName && !op.templateId) {
        return alert('The templateId option is required.');
    }

    // Get a template
    const rebuildTemplateCore = function (options) {
        window.mtappVars.DataAPI.getTemplate(options.siteId, options.templateId, function (template) {
            const templateName = template.name;

            const rebuild = function () {
                window.mtappVars.DataAPI.publishTemplate(options.siteId, options.templateId, '{}', function (response) {
                    if (typeof response.status !== 'undefined' && response.status === 'success') {
                        msg({
                            type: 'success',
                            msg: `「${templateName}」を再構築しました。`,
                            dismissible: true
                        });
                    }
                });
            };

            if (options.noConfirm) {
                rebuild();
            } else {
                modalConfirm({
                    type: 'warning',
                    content: `「${templateName}」を再構築しますか？`,
                    callback: rebuild
                });
            }
        });
    };

    if (typeof op.templateName === 'string' && op.templateName) {
        window.mtappVars.DataAPI.listTemplates(op.siteId, function (response) {
            if (response.totalResults === 0) {
                return alert(`${op.templateName} is not found.`);
            }

            const template = response.items.find((t) => t.name === op.templateName);
            if (!template) {
                return alert('The templateName option is invalid.');
            }

            op.templateId = template.id;

            rebuildTemplateCore(op);
        });
    } else {
        rebuildTemplateCore(op);
    }
}
